import { formatDate } from "@angular/common";
import { Injectable } from "@angular/core";
import { DynamicFieldValueModel } from "@core/api/models/dynamicfield/dynamicfield-value.model";
import { EnabledDynamicFieldModel } from "@core/api/models/dynamicfield/enabled-dynamicfield.model";

export class CustomField{
    constructor(
        public id:string,
        public name:string,
        public value:any,
        public type:"string"|"text"|"email"|"numeric"|"date"|"time"|"select"|"nationalnumber"|"checkbox"|'hidden'|'password' = "string",
        public size:"small"|"half"|"date"|"time"|"" = "",
        public required:boolean = false,
        public options:Array<{value:string,label:string, position:number}> = [],
        public mask:string = '',
        public enabledForSubscriber:boolean = false,
        public requiredOnlyForSubscriber:boolean = false,
        public hiddenForStudent:boolean = false,
        public hidden:boolean = false
        ){ }

    /*De effectieve waarde*/
    getValue(){
        if(this.value){
            switch(this.type){
                case "date":
                    return  formatDate(new Date(this.value),'yyyy-MM-dd','nl_BE');
                case "checkbox":
                    return this.value ? true : false;
                case "nationalnumber":
                    return this.value.replace(/\D/g,'');
                default:
                    return this.value;
            }
        }else{
            return '';
        }
    }
    /*De waarde om te printen in HTML*/
    getPrintValue(){
        if(this.value){
            switch(this.type){
                case "date":
                    return  formatDate(new Date(this.value),'dd/MM/yyyy','nl_BE');
                case "select":
                    return  this.options.find(x => x.value == this.value)?.label??'';
                case "checkbox":
                    return this.value ? "ja" : "nee"
                default:
                    return this.value;
            }
        }else{
            return '-';
        }
    }
}



@Injectable({
    providedIn: 'root'
  })
  export class CustomFieldAdapter {

    constructor() {

    }

    setSize(type:string){
        switch(type){
            case "date" :
                return "date";
            case "time" :
                return "time";
            case "text":
            case "choice":
                return "half";
            default :
                return "half";
        }
    }

    setType(type:'text'|'string'|'integer'|'float'|'date'|'time'|'choice'|'choice_radio'|'choice_multiple'|'hidden'|'password'){
        switch(type){
            case "integer":
            case "float":
                return "numeric"
            case "choice" :
            case "choice_radio" :
            case "choice_multiple" :
                return "select";
            default :
                return type;
        }
    }

    adapt(item: EnabledDynamicFieldModel): CustomField {
        // Sort choices by position if they exist, otherwise set to an empty array
        const sortedChoices = typeof item.dynamicField.choices !== 'undefined'
        ? item.dynamicField.choices.sort((a, b) => a.position - b.position).map(x => ({
            value: x.value,
            label: x.label,
            position: x.position,
            }))
        : [];
      return new CustomField(
        item.dynamicField.id,
        item.dynamicField.name,
        (typeof item.dynamicField.value === 'undefined')? '':item.dynamicField.value,
        this.setType(item.dynamicField.type),
        this.setSize(item.dynamicField.type),
        false,
        sortedChoices,
        undefined,
        item.enabledForSubscriber,
        item.requiredForPersonsSubscriber,
        item.hiddenForStudent
      );
    }

    adaptFromDynamicFieldValue(item: DynamicFieldValueModel):CustomField{
        // Sort choices by position if they exist, otherwise set to an empty array
        const sortedChoices = typeof item.dynamicField.choices !== 'undefined'
        ? item.dynamicField.choices.sort((a, b) => a.position - b.position).map(x => ({
            value: x.value,
            label: x.label,
            position: x.position,
            }))
        : [];
        return new CustomField(
            item.dynamicField.id,
            item.dynamicField.name,
            item.value,
            this.setType(item.dynamicField.type),
            this.setSize(item.dynamicField.type),
            false,
            sortedChoices
    
          );
    }

    adaptFromDynamicField(item: any):CustomField{
        // Sort choices by position if they exist, otherwise set to an empty array
        const sortedChoices = typeof item.choices !== 'undefined'
        ? item.choices.sort((a:any, b:any) => a.position - b.position).map((x:any) => ({
            value: x.value,
            label: x.label,
            position: x.position,
            }))
        : [];
        return new CustomField(
            item['@id'].split('/').pop(),
            item.name,
            item.value,
            this.setType(item.type),
            this.setSize(item.type),
            true,
            sortedChoices
    
          );
    }
  }
